export const SECTIONIDS = {
    HERO: "home",
    WORK: "works",
    SERVICES: "services",
    ABOUT: "about-us",
    CONTACT: "contact-us"
  };
  